// ExamListPage.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import BASE_URL from "../config";
import "bootstrap/dist/css/bootstrap.min.css";
//const EXAMS_API = `${BASE_URL}/api/exams`;
const SUBJECTS_API = `${BASE_URL}/api/subjects`;
const ExamPageList = () => {
  const [exams, setExams] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editExam, setEditExam] = useState(null);
  const [subjects, setSubjects] = useState([]);
  const [newSubject, setNewSubject] = useState({ SubjectID: "", TotalMarks: "", MinMarks: "" });
  const [allSubjects, setAllSubjects] = useState([]);
  const [editSubjectId, setEditSubjectId] = useState(null);
  const [editedSubject, setEditedSubject] = useState({ TotalMarks: "", MinMarks: "" });
  const fetchAllSubjects = () => {
    axios.get(SUBJECTS_API).then((res) => setAllSubjects(res.data));
  };
  useEffect(() => {
    fetchExams();
    fetchAllSubjects();
  }, []);
  // delete subject
const handleDeleteSubject = async (subjectId) => {
  if (!window.confirm("Delete this subject?")) return;
  try {
    await axios.delete(
      `${BASE_URL}/api/exams/${editExam.ExamID}/${editExam.CourseID}/${editExam.ClassID}/${editExam.SectionID}/${editExam.AcademicYearID}/subjects/${subjectId}`
    );
    alert("Subject deleted");
    handleManageSubjects(editExam);
  } catch (err) {
    alert("Error deleting subject");
  }
};
  const handleAddSubject = async () => {
  if (!newSubject.SubjectID || !newSubject.TotalMarks || !newSubject.MinMarks) {
    alert("Please fill all subject details before adding.");
    return;
  }
  try {
    await axios.post(`${BASE_URL}/api/exams/${editExam.ExamID}/subjects`, {
      SubjectID: newSubject.SubjectID,
      TotalMarks: newSubject.TotalMarks,
      MinMarks: newSubject.MinMarks,
      CourseID: editExam.CourseID,
      ClassID: editExam.ClassID,
      SectionID: editExam.SectionID,
      AcademicYearID: editExam.AcademicYearID,
    });
    // refresh subjects
    handleManageSubjects(editExam);
    setNewSubject({ SubjectID: "", TotalMarks: "", MinMarks: "" });
    alert("Subject added successfully ✅");
  } catch (err) {
    console.error("Error adding subject:", err);
    // ✅ Show friendly message if backend provided one
    if (err.response && err.response.data && err.response.data.message) {
      alert(err.response.data.message);
    } else {
      alert("Something went wrong while adding subject. Please try again.");
    }
  }
};
  const handleEditSubjectClick = (subject) => {
    setEditSubjectId(subject.SubjectID);
    setEditedSubject({ TotalMarks: subject.TotalMarks, MinMarks: subject.MinMarks });
  };
  const handleCancelEdit = () => {
    setEditSubjectId(null);
    setEditedSubject({ TotalMarks: "", MinMarks: "" });
  };
  const handleSaveSubject = async () => {
  try {
    await axios.put(
      `${BASE_URL}/api/exams/${editExam.ExamID}/${editExam.CourseID}/${editExam.ClassID}/${editExam.SectionID}/${editExam.AcademicYearID}/subjects/${editSubjectId}`,
      { MinMarks: editedSubject.MinMarks, TotalMarks: editedSubject.TotalMarks }
    );
    alert("Subject updated");
    handleManageSubjects(editExam); // refresh list
    handleCancelEdit();
  } catch (err) {
    alert("Error updating subject");
  }
};
  // fetch all exams
  const fetchExams = async (term = "") => {
    try {
      const res = await axios.get(`${BASE_URL}/api/exams`, {
      params: { search: term.trim() || undefined }, // send search if provided
    });
      setExams(res.data);
    } catch (err) {
      console.error("Error fetching exams", err);
    }
  };
  useEffect(() => {
    fetchExams();
  }, []);
// on searchTerm change → fetch exams matching name
useEffect(() => {
  const delayDebounce = setTimeout(() => {
    fetchExams(searchTerm);
  }, 400); // debounce for smoother typing
  return () => clearTimeout(delayDebounce);
}, [searchTerm]);
  // delete exam by examId, courseId, classId, year
  const handleDelete = async (exam) => {
    if (!window.confirm("Are you sure you want to delete this exam?")) return;
    try {
      await axios.delete(
        `${BASE_URL}/api/exams/${exam.ExamID}/${exam.CourseID}/${exam.ClassID}/${exam.SectionID}/${exam.AcademicYearID}`
      );
      alert("Exam deleted successfully");
      fetchExams();
    } catch (err) {
      console.error("Error deleting exam", err);
      alert("Error deleting exam");
    }
  };
  // manage subjects (navigate or call API)
  const handleManageSubjects = async (exam) => {
    try {
      // call backend with params
      const res = await axios.get(
        /* `${BASE_URL}/api/exams/${exam.ExamID}/subjects?courseId=${exam.CourseID}&classId=${exam.ClassID}&yearId=${exam.AcademicYearID}` */
        `${BASE_URL}/api/exams/${exam.ExamID}/${exam.CourseID}/${exam.ClassID}/${exam.SectionID}/${exam.AcademicYearID}/subjects`
      );
       setSubjects(res.data);
    setEditExam(exam);
     console.log("Subjects:", res.data);
      // or redirect to another page if needed
    } catch (err) {
      console.error("Error fetching subjects", err);
      alert("Error loading subjects");
    }
  };
  return (
    <div className="container mt-5">
      <h2 className="mb-4">Exams</h2>
      <input
        type="text"
        className="form-control mb-3"
        placeholder="Search Exam Name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
           <table className="table table-bordered table-striped mt-3">
        <thead>
          <tr>
            <th>Exam Name</th>
            <th>Course</th>
            <th>Class</th>
            <th>Academic Year</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {exams.length === 0 ? (
            <tr>
              <td colSpan="5" className="text-center">
                No exams found
              </td>
            </tr>
          ) : (
            exams.map((exam, index) => (
              <tr key={index}>
                <td>{exam.ExamName}</td>
                <td>{exam.CourseName}</td>
                <td>{exam.ClassName}</td>
                <td>{exam.AcademicYearName}</td>
                <td>
                  <button
                    className="btn btn-primary btn-sm me-2"
                    onClick={() => handleManageSubjects(exam)}
                  >
                    Manage Subjects
                  </button>
                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => handleDelete(exam)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      {editExam && (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Manage Subjects for: {editExam.ExamName}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setEditExam(null)}
                ></button>
              </div>
              <div className="modal-body">
                <h6>Subjects</h6>
                <table className="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th>Subject Name</th>
                      <th>Total Marks</th>
                      <th>Min Marks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {subjects.map((subj) => (
                      <tr key={subj.SubjectID}>
                        <td>{subj.SubjectName}</td>
                        <td>
                          {editSubjectId === subj.SubjectID ? (
                            <input
                              type="number"
                              className="form-control"
                              value={editedSubject.TotalMarks}
                              onChange={(e) =>
                                setEditedSubject({ ...editedSubject, TotalMarks: e.target.value })
                              }
                            />
                          ) : (
                            subj.TotalMarks
                          )}
                        </td>
                        <td>
                          {editSubjectId === subj.SubjectID ? (
                            <input
                              type="number"
                              className="form-control"
                              value={editedSubject.MinMarks}
                              onChange={(e) =>
                                setEditedSubject({ ...editedSubject, MinMarks: e.target.value })
                              }
                            />
                          ) : (
                            subj.MinMarks
                          )}
                        </td>
                        <td>
                          {editSubjectId === subj.SubjectID ? (
                            <>
                              <button className="btn btn-success btn-sm me-2" onClick={handleSaveSubject}>
                                Save
                              </button>
                              <button className="btn btn-secondary btn-sm" onClick={handleCancelEdit}>
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-warning btn-sm me-2"
                                onClick={() => handleEditSubjectClick(subj)}
                              >
                                Edit
                              </button>
                              <button
                                className="btn btn-danger btn-sm"
                                onClick={() => handleDeleteSubject(subj.SubjectID)}
                              >
                                Delete
                              </button>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <h6 className="mt-4">Add Subject</h6>
                <div className="row g-2 align-items-end">
                  <div className="col-md-3">
                    <select
                      className="form-select"
                      value={newSubject.SubjectID}
                      onChange={(e) =>
                        setNewSubject({ ...newSubject, SubjectID: e.target.value })
                      }
                    >
                      <option value="">Select Subject</option>
                      {allSubjects.map((subj) => (
                        <option key={subj.SubjectID} value={subj.SubjectID}>
                          {subj.SubjectName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-3">
                    <input
                      type="number"
                      placeholder="Total Marks"
                      className="form-control"
                      value={newSubject.TotalMarks}
                      onChange={(e) =>
                        setNewSubject({ ...newSubject, TotalMarks: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <input
                      type="number"
                      placeholder="Min Marks"
                      className="form-control"
                      value={newSubject.MinMarks}
                      onChange={(e) =>
                        setNewSubject({ ...newSubject, MinMarks: e.target.value })
                      }
                    />
                  </div>
                  <div className="col-md-3">
                    <button className="btn btn-success w-100" onClick={handleAddSubject}>
                      Add Subject
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditExam(null)}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default ExamPageList;
